<!--
  Eine Zeile aus farbigem Typ-Chip und Zeitraum, etwa "[EINMALIG] nur am 26.08.2026"
  Icon, Label und Farben stammen aus RESTRIKTION_TYPE_CONFIG
-->
<template>
  <div class="restriktionen-zeitraum-zeile">
    <div class="restriktionen-zeitraum-zeile__kopf">
      <span
        class="restriktionen-zeitraum-zeile__badge"
        :style="{
          backgroundColor: typeConfig(type).bgColor,
          color: typeConfig(type).textColor,
        }"
      >
        <component :is="typeConfig(type).icon" :size="12" />
        {{ typeConfig(type).modalLabel }}
      </span>
      <span class="restriktionen-zeitraum-zeile__zeitraum">{{ zeitraum }}</span>
      <span v-if="zusatz" class="restriktionen-zeitraum-zeile__zusatz">{{ zusatz }}</span>
    </div>

    <div v-if="$slots.default" class="restriktionen-zeitraum-zeile__details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import restriktionenTypMixin from './restriktionen-typ.mixin.js';

export default {
  name: 'RestriktionenZeitraumZeileComponent',
  mixins: [restriktionenTypMixin],
  props: {
    type: {
      type: String,
      required: true,
    },
    zeitraum: {
      type: String,
      required: true,
    },
    zusatz: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.restriktionen-zeitraum-zeile__kopf {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.restriktionen-zeitraum-zeile__badge {
  display: inline-flex;
  gap: 8px;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  font-size: 11px;
  line-height: 13px;
  font-weight: 500;
}

.restriktionen-zeitraum-zeile__zeitraum {
  font-size: 13px;
  color: var(--text-body);
}

.restriktionen-zeitraum-zeile__zusatz {
  font-size: 13px;
  color: var(--text-muted);
}

.restriktionen-zeitraum-zeile__details {
  margin-top: 4px;
  font-size: 13px;
  line-height: 20px;
  color: var(--text-body);
}
</style>
